export default __webpack_public_path__ + "static/media/register-dark.2b051707.svg";